<script setup>
import { modelForms } from 'src/models'
import Breadcrumbs from 'src/modules/admin/components/Breadcrumbs.vue'
import { computed, getCurrentInstance, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const vm = getCurrentInstance()
const trackPage = vm.appContext.config.globalProperties.$trackPage

const props = defineProps({
  modelName: {
    type: String,
    required: false,
    default: null
  }
})

const route = useRoute()
const component = computed(() => modelForms[props.modelName || route.params.name])
const componentRef = ref(null)
const loading = ref(false)

function openModelForm () {
  const modelForm = componentRef.value?.$refs?.modelForm

  if (!modelForm) {
    return
  }

  modelForm.$data.dialog = false

  modelForm.show({ id: route.params.id })
}

watch(componentRef, () => {
  if (componentRef.value) {
    openModelForm()
    trackPage(componentRef.value)
  }
})
</script>

<template>
  <q-page class="q-pa-sm">
    <q-inner-loading :showing="loading" />
    <breadcrumbs name="Edit" />
    <component
      :is="component"
      ref="componentRef"
      @vue:mounted="loading = false"
    />
  </q-page>
</template>

<style lang="scss" scoped>
</style>
